import { createSlice } from "@reduxjs/toolkit";

import { isCategoryRestricted, pickAccessibleCategory } from "../../helpers/dealCategoryProducts";

const LOGIN_FULFILLED_TYPES = [
  "auth/loginUser/fulfilled",
  "auth/loginUserAfterOtp/fulfilled",
  "auth/loginUserAfterAuthenticator/fulfilled",
];

const persistActiveCategory = (category) => {
  if (category) {
    localStorage.setItem("activeCategory", JSON.stringify(category));
  } else {
    localStorage.removeItem("activeCategory");
  }
  return category;
};

const syncActiveCategoryFromList = (state, categories, preferredId = null) => {
  const next = pickAccessibleCategory(categories, preferredId);
  state.activeCategory = persistActiveCategory(next);
};

const getInitialActiveCategory = () => {
  try {
    const stored = JSON.parse(localStorage.getItem("activeCategory"));
    const user = JSON.parse(localStorage.getItem("busUser"));
    const categories = user?.dealCategories || [];

    if (categories.length > 0) {
      return persistActiveCategory(
        pickAccessibleCategory(categories, stored?.dealCategoryId),
      );
    }

    if (stored && !isCategoryRestricted(stored?.statusId)) {
      return stored;
    }

    return null;
  } catch {
    return null;
  }
};

const initialState = {
  activeCategory: getInitialActiveCategory(),
};

const dealCategorySlice = createSlice({
  name: "dealCategory",
  initialState,
  reducers: {
    setActiveCategory: (state, action) => {
      state.activeCategory = persistActiveCategory(action.payload);
    },
  },
  extraReducers: (builder) => {
    const syncFromUserPayload = (state, action) => {
      const categories = action.payload?.dealCategories;
      if (!Array.isArray(categories)) return;
      syncActiveCategoryFromList(
        state,
        categories,
        state.activeCategory?.dealCategoryId,
      );
    };

    builder.addMatcher(
      (action) => LOGIN_FULFILLED_TYPES.includes(action.type),
      syncFromUserPayload,
    );
    builder.addMatcher(
      (action) => action.type === "auth/getOrgDealCategories/fulfilled",
      (state, action) => {
        if (!Array.isArray(action.payload)) return;
        syncActiveCategoryFromList(
          state,
          action.payload,
          state.activeCategory?.dealCategoryId,
        );
      },
    );
    builder.addMatcher(
      (action) =>
        action.type === "auth/logout/fulfilled" ||
        action.type === "auth/logout/rejected",
      (state) => {
        state.activeCategory = persistActiveCategory(null);
      },
    );
  },
});

export const { setActiveCategory } = dealCategorySlice.actions;
export default dealCategorySlice.reducer;
